import { IconProps, iconA11yProps } from '../types';

export const SortArrow = ({ classNames, label }: IconProps) => (
    <svg className={classNames} fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" {...iconA11yProps(label)}>
        <path
            d="M21.3574 11.9659L13.0934 20.8519C12.9531 21.0015 12.7837 21.1207 12.5955 21.2022C12.4073 21.2836 12.2045 21.3257 11.9994 21.3257C11.7944 21.3257 11.5915 21.2836 11.4033 21.2022C11.2152 21.1207 11.0457 21.0015 10.9054 20.8519L2.64142 11.9659"
            strokeWidth="2"
            strokeMiterlimit="10"
        />
        <path d="M12 22.019L12 0.00104332" strokeWidth="2" strokeMiterlimit="10" />
    </svg>
);
